export default {
    //配件申请单
    partapplyname: 'PartApply Code',
    servicename: 'Service Code',
    applytype: 'Apply Code',
    approvalstatus: 'Approval Status',
    From: ' From',
    To: ' To',
    Year: 'Year',
    Month: 'Month',

    //系统公告
    startDate: 'StartDate code',
    endDate: 'EndDate code',
    noticeType: 'Notice Type',
    noticeTitle: 'Notice Title',
    noticeState: 'Notice State',

    //Menu
    PARTS: "Parts Management",
    PARTSAPPLY: "Parts Application",
    NEWORDER: "Parts Sales",
    PARTSSIGN: "Parts Receipt",
    SITERETURN: "Parts Return",
    PARTSRETURNLIST: "Old Parts Back to the Factory",
    SITEINV: "Parts Stock",
    PARTSTOCKTRANSACTION: "Parts Stocking Record",
    WORKORDER: "Service Management",
    AMOUNTADJUSTMENT: "Quota Adjustment",
    AMOUNTCHANGELOG: "Quota Adjustment Record",
    WORKORDERLIST: "Work Order",
    CLAIMFINE: "Bonus and Punishment",
    EXPENSECLAIM: "Expense Settlement",
    BASEDATA: "Basic Data",
    BASICDATA: "Service Station Profile",



    //js error
    HasCancelledForDeleting: "Deletion Canceled",
    PleaseChooseAtLeastOne: "Please select an item at least!",
    ResetCanOnlySelectOne: "One item only!",
    PleaseInputRequiredFields: "Please enter the required fields!",
    PleaseChooseOneLine: "Please select an item!",
    PleaseChooseProvince: "Please select the province!",
    PleaseChooseCity: "Please select the city!",
    PleaseChoosePart: "Please select the part!",
    PleaseOneLine: "Please select an item!",
    PleaseChooseStationWarehouse: "Please select the warehouse!",
    ResetPassAndDeterminPass: "Password cannot be blank!",
    PassIsToLong: "The password is too long!",
    WhetherDeterminAndSendInvoice: "Confirmed and sent the invoice or not?",
    Tip: "Tips",
    HasCancelled: "Canceled",
    ThisPartLineHasExisted: "Existed Parts Details",
    PleaseSaveAndAdd: "Please save first and then add details!",
    NewOrderNotSaveSureQuit: "Data has not been saved! Are you sure to quit?",
    BeginNeedLessThanEnd: "The start time must be earlier than the end time!",
    CanNotDelete: "The submitted application cannot be deleted!",
    ThisActionDeletePerpetually: "Deleted data cannot be recovered, are you sure to continue?",
    EndNeedMoreThanBegin: "The end time must be later than the start time!",
    OnlyInt: "Integer is allowed only!",
    PleaseInputLessThan100000: "Please enter a number less than 100,000!",
    ModifySuccess: "Successfully modified!",
    RequiredIncludeOneLine: "A detailed item is necessary!",
    DeterminClose: "Close confirmation",
    PhoneFormatNotSuit: "Incorrect phone format! ",
    FreightAmountNeedInNormal: "Transportation costs must be in the normal range!",
    WhetherSendDetermin: "Confirm the delivery or not?",
    WhetherDeterminSign: "Receive or not?",
    ExistSameFile: "Please donot upload the same document!",
    FileIn10M: "Attachment must be less than 10M!",
    PleaseSave: "Please donot add details to submitted document!",
    NotSingleAndRejectCanNotAdd: "Please donot add details to submitted document!",
    NotSingleAndRejectCanNotDel: "Please donot delete details from submitted document!",
    NotSingleAndRejectCanNotModify: "Please donot modify details in submitted document!",
    PleaseInputBeginTime: "Please enter the departure time!",
    PleaseInputBeginPlace: "Please enter the departure address!",
    PleaseInputArriveTime: "Please enter the arrival time!",
    PleaseInputArrivePlace: "Please enter the arrival address!",
    PleaseUpLoadPicture: "Please upload photos!",
    PleaseInputFinishTime: "Please enter the completion time!",
    ExitNotRepeat: "Repeated Part!",
    PleaseChooseWorker: "Please choose a service person!",
    WhetherDispatchAuto: "Dispatch automatically or not?",
    SendLessThanBack: "The number of delivered parts cannot be larger than the returned!",
    SendLessThanZero:"The number of shipments should be more than 0",
    BackLessThan100000: "The number of returned parts cannot be larger than 100,000!",
    SendLessThan100000: "The number of delivered parts cannot be larger than 100,001!",
    SendLessThanCheck: "The number of delivered parts cannot be larger than the approved!",
    BackReasonLessThan100: "The length of deliver's address must be less than 100!",
    AddressLessThan100: "The length of return reason must be less than 101!",
    RequiredMoeThanOneLine: "At least one item of returned parts is required!",
    AppliedquantityREQUIRED: "Applied quantity is required!",
    DeliveryinformationREQUIRED: "Delivery information is required!",
    DocumentdetailREQUIRED: "Document detail is required!",
    ResetpasswordREQUIRED: "Reset password is required!",
    DeliveredquantityREQUIRED: "Delivered quantity is required!",
    ConfirmpasswordREQUIRED: "Confirm password is required!",
    NumberRequired: "Document number is required!",
    ProductRequired: "Product ID is required!",
    IDREQUIRED: "ID is required!",
    PartsDetailsIDREQUIRED: "Parts Details ID is required!",
    ServiceStaffIDREQUIRED: " Service Staff ID is required!",
    PartsIDREQUIRED: "Parts ID is required!",
    WarehouseIDREQUIRED: "Warehouse ID is required!",
    SoldquantityREQUIRED: "Sold quantity is required!",

    DcoumentInfoRequired: "Document information is required!",
    RetrieveInfoRequired: "Relative information could not be found!",
    ServiceStationRequired: "Service station is required!",
    ArticleNotFound: "This article coud not be found!",
    InfoNotFound: "Relative information could not be found!",
    ServiceStationNotFound: "This service station does not exist!",
    PleaseAddAndSave: "Please add details!",
    DoucmentNotBelongWareHouse: "Incorrect service station! Please check!",
    OnlySingleDetermin: "Confirmation is not allowed!",
    DocumentNotWarehouse: "Incorrect warehouse! Please check!",
    NotAchieveExportData: "No Imported data!",
    UserNotSetStation: "Please assign a service station to this user!",
    ThisStationQuotaNotEnough: "Insufficient quota!",
    ModifyNotAllowed: "Modification is not allowed for submitted document!",
    CountMoreThanZero: "Quantity should be larger than 0!",
    TheParamError: "Incorrect parameter!",
    UserNotSetDepart: "This user has no business unit!",
    UserNotSetPrincipal: "This business unit has no owner!",
    UserNotSetMechanism: "This owner has no organization!",
    SentStateRquired: "Delivery state must be Delivered or Partially Received!",
    Successfullyreceived: "Successfully received!",
    Successfullysent: "Successfully sent!",
    Successfullydeactivated: "Successfully deactivated!",
    Successfullydispatched: "Successfully dispatched!",
    Successfullyreassigned: "Successfully reassigned!",
    Successfullyadded: "Successfully added!",
    Successfullycreated: "Successfully created!",
    Successfullyresetted: "Successfully resetted!",
    Successfullydealt: "Successfully dealt!",
    Successfullysaved: "Successfully saved!",
    Successfullycreated: "Successfully created!",
    Successfullydeleted: "Successfully deleted!",
    Successfullyconfirmed: "Successfully confirmed!",
    Successfullydelivered: "Successfully delivered!",
    Successfullyreceived: "Successfully received!",
    DocumentNotBelongStation: "Incorrect service station! Please check!",
    OnlyModifyNotAdd: "Modification only!",
    PleaseChoose: "Please choose the year first!",
    BackCountMoreThanNotBackCount: "The number of parts back to factory could not be larger than the one to be back to factory!",
    MemoLessThan100: "The length of memo should not be longer than 100!",
    Insufficientquantity: "Insufficient quantity! Current quantity of parts to be back to factory is ",
    CanNotAdd: "Details could not be created!",
    PleaseMaintainSysParam: "Please enter system parameter in CRM!",
    OnlyDispatch: "Dispatch is not allowed for this work order!",
    ThisStationNotExitWarehouse: "This service station has no warehouse!",
    NotFoundUserStation: "This user has no service station!",
    BelongStationAddressNotFound: "This warehouse has no address!",
    NotAchieveOutParam: "Export parameter could not be found!",
    OutParamNotExitAvailableQuota: "Export parameter has no available quota value!",

    Input: "Please input",
    BaseInfo: "Basic Information",
    ReplaceDate: "Replaced Date",
    BTFAmount: "Number of Parts Back to Factory",
    TOBTFAmount: "Number of Parts to be Back to Factory",
    CostOutRange: "Transportation costs must be in the normal range!",
    DeliveryConfirm: "Delivery Confirm",

    ResetPSW: "Password Reset",
    UserName: "User's name",
    OriginPSW: "Origin Password",
    NewPSW: "New Password",
    ConfirmPSW: "Confirm Password",
    Upload: "Drop file here or click to upload",

    ACT: "Action",
    COMMON: "Common Information",
    SERVICE: "Service Information",
    Dispatch: "Dispatch Information",
    TotalCost: "Total Cost",

    Inquery: "Inquery",
    InqueryCon: "Inquery Content",
    ServiceAmountLess: "Service Amount Less Than",
    TheCurrentAmount: "The Current Amount",
    DeliveryDetail: "Delivery Detail",
    Amounts: "Amounts",
    TotalAmounts: "Total Amounts",
    CostMustBeInNormal: "Transportation costs must be in the normal range!",
    AppliedQuantity: "Apply Quantity",
    BranchStock: "Branch Stock",
    DownLoad: "DownLoad",
    ReplyContent: "Reply Content",


    Province: "Province",
    City: "City",
    County: "County",
    Code: "Code",
    Address: "Address",
    DocumentDownload: "Document Download",

    Address: "Address",
    MaintenanceProjectName: "Maintenance Project Name",
    MaintenanceTimeDes: "Maintenance Time Description",
    LaborHourUnitPrice: "Unit Price",
    FaultSys: "Fault System",
    FaultPhen: "Fault Phenomenon",
    FaultUnit: "Fault Unit",
    FaultPart: "Fault Part",
    CustomerName: "Customer Name",
    ProductModel: "Product Model",
    ProductType: "Product Type",
    PleaseDispatchFir: "Please Dispatch Firstly",
    ApplyCountNotEmpty: "Apply cannot be Empty",
    Supplier: "Supplier Name",


    All: "All",
    Today: "Today",
    Tomorrow: "Tomorrow",
    MapLoad: "Map Loading...",
    ToBeAssigned: "To be assigned:",
    EnterName: "Please Enter Name",
    ServiceCalendar: "Service Calendar",
    CalenderLoading: "Calender Loading...",
    Warehouse: "Warehouse",
    SiteInvNowQty:"SiteInvNowQty",
    SeeRealInv:"ShowRealInv",
    OnlySeeNowInv:"OnlyShowInv"
};    



// WEBPACK FOOTER //
// ./src/module/locale/lang/en.js